<app-advanced-search
  [initialRows]="initialRows"
  [fieldsToSearch]="fieldsToSearch"
  [operations]="operations"
  [defaultField]="defaultField"
  [defaultOperation]="defaultOperation"
  (onApply)="onApply.emit($event)"
></app-advanced-search>
